import Hero from "./components/Hero";
import LiquidMetalBackground from "./components/LiquidMetalBackground";
import Navbar from "./components/Navbar";

export default function Home() {
  return (
    <main className="relative min-h-screen w-full overflow-hidden bg-[#0a0a0b]">
      {/* Subtle grain / vignette layer beneath content for depth */}
      <div
        className="pointer-events-none absolute inset-0 z-0"
        style={{
          background:
            "radial-gradient(1200px 800px at 20% 30%, rgba(255,255,255,0.04), transparent 60%), radial-gradient(900px 700px at 80% 80%, rgba(255,255,255,0.03), transparent 60%)",
        }}
      />

      <Navbar />
      <Hero />

      {/* Draggable liquid metal object — floats above everything */}
      <LiquidMetalBackground />
    </main>
  );
}